import * as React from "react";
import { Link } from "react-router";

import { PageBreadcrumbs, PageLayout } from "@/shared/components";

import styles from "./TriggerFormPage.module.css";

export interface TriggerFormPageProps {
  /** The heading, and the last crumb of the trail. */
  title: string;
  /** One line of orientation under the heading. */
  subtitle: string;
  /** Crumbs between the triggers list and this page. */
  crumbs?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * The chrome both trigger-authoring pages sit in, so create and edit read as
 * the same page: a trail back to the list, the heading, and a line saying what
 * the page is for. The form below brings its own sections and its own bar.
 */
export function TriggerFormPage({
  title,
  subtitle,
  crumbs,
  children,
}: TriggerFormPageProps) {
  return (
    <PageLayout
      title={`Roboto - ${title}`}
      headerContentLeft={
        <PageBreadcrumbs>
          <Link to="/triggers">Triggers</Link>
          {crumbs}
          <span>{title}</span>
        </PageBreadcrumbs>
      }
    >
      <div className={styles.page} data-testid="trigger-form-page">
        <header>
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.lede}>{subtitle}</p>
        </header>
        {children}
      </div>
    </PageLayout>
  );
}
